<h2 mat-dialog-title>{{ isEdit ? 'Edit group' : 'Create group' }}</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="gd-content">
    <mat-form-field appearance="fill" class="gd-field" subscriptSizing="dynamic">
      <mat-label>Group name</mat-label>
      <input matInput formControlName="name" aria-label="Group name" />
      <mat-error>Group name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="gd-field" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        formControlName="description"
        rows="3"
        aria-label="Group description"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="fill" class="gd-field" subscriptSizing="dynamic">
      <mat-label>Add Icon</mat-label>
      <mat-select formControlName="icon" aria-label="Select icon to represent group">
        @for (i of icons; track i.value) {
          <mat-option [value]="i.value">
            <mat-icon>
              {{ i.value }}
            </mat-icon>
          </mat-option>
        }
        <mat-select-trigger
          ><mat-icon>{{ form.get('icon')?.value }}</mat-icon></mat-select-trigger
        >
      </mat-select>
    </mat-form-field>

    @if (!isEdit) {
      <mat-form-field appearance="fill" class="gd-field" subscriptSizing="dynamic">
        <mat-label>Add students</mat-label>
        <mat-select formControlName="memberIds" multiple aria-label="Select students to add">
          @for (s of availableStudents; track s.id) {
            <mat-option [value]="s.user.id">
              {{ s.user.preferred_name || s.user.first_name }} {{ s.user.last_name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" type="submit">
      {{ isEdit ? 'Save changes' : 'Create group' }}
    </button>
  </mat-dialog-actions>
</form>
